import {getUsersForApp} from 'src/services/Discovery/Discovery';
import {
  cacheKeyForDiscoveryUsersForApp
} from 'src/services/shared/serviceConstants';
import {AppUserGrid} from 'src/pages/DashboardPage/Discovery/AppUsersPanel/AppUserGrid';
import {useQueryWithAccessToken} from "src/hooks/TanstackHooks";
import {useTheme} from "@mui/material";
import {useParams} from "react-router";
import {buildUserConsentedColumns} from "./AppUsersColumnBuilder";
import {getGridHeadingCount} from "../../../../components/common/Tables/Utilities";


export const AppUsersPanel = (props: {appPubId?: string}) => {
  // The dashboard passes appPubId; the /users-for-app/:appPubId route does not.
  const params = useParams<{appPubId: string}>();
  const appPubId = props.appPubId ?? params.appPubId ?? '';
  const theme = useTheme();
  const queryResult = useQueryWithAccessToken({
      queryKey: [cacheKeyForDiscoveryUsersForApp(appPubId)],
      queryFunction: getUsersForApp,
      queryFunctionVariables:{appPubId: appPubId}
    }
  );

  return  <AppUserGrid
    users={queryResult?.data?.latest_saas_users}
    columns={buildUserConsentedColumns(theme)}
    isLoading={queryResult.isLoading}
    panelHeading={getGridHeadingCount(queryResult?.data?.latest_saas_users, 'App Users')}
  />
}